var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[(_vm.value)?_c('span',{staticClass:"m-badge m-badge--success"}):_c('span',{staticClass:"m-badge m-badge--secondary"})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a886018","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/metronic/table/value/BooleanColorDot.vue
// module id = LLGD
// module chunks = 0 1 2